import styled from 'styled-components';
import { FontSizes } from '../typography/typography.styles';

export const HintSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  background-color: ${({ theme }) => theme.colors.namedColors.white};
  border-radius: 1.2rem;
  border: 1px solid
    ${({ theme }) => theme.colors.passwordValidationMarker.backgroundColor};
  padding: 1.6rem;
`;

export const HintSectionTitle = styled.p`
  color: ${({ theme }) => theme.colors.baseColors.gray150};
  font-size: ${FontSizes.medium};
  font-style: normal;
  font-weight: 700;
  line-height: 2.2rem;
  letter-spacing: 0.5px;
`;

export const HintItemContainer = styled.div`
  padding-left: 25px;
  position: relative;

  &:before {
    display: block;
    content: '';
    width: 3px;
    height: 3px;
    background: ${({ theme }) => theme.colors.baseColors.grey150};
    position: absolute;
    top: 9px;
    left: 8px;
    border-radius: 50%;
  }

  svg {
    display: block;
    width: 20px;
    height: 20px;
    object-fit: contain;
    path {
      fill: ${({ theme }) => theme.colors.baseColors.grey150};
    }
  }

  p {
    font-size: ${FontSizes.medium};
    font-weight: 500;
    line-height: 2rem;
    color: ${({ theme }) => theme.colors.baseColors.grey150};
  }

  small {
    font-size: ${FontSizes.normal};
    font-weight: 500;
    line-height: 2rem;
    color: ${({ theme }) => theme.colors.baseColors.grey150};
  }
`;
